import { Button, Typography } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { Vocabulary } from "../Utils/Vocabulary";
import styles from "../Styles/appInactivePage.module.css";

export default function AppInactivePage() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <BlockIcon className={styles.icon} />
        </div>

        <Typography variant="h5" className={styles.title}>
          {Vocabulary.applicationInactive}
        </Typography>

        <Typography variant="body1" className={styles.message}>
          {Vocabulary.applicationInactiveMessage}
        </Typography>

        <div className={styles.helpBox}>
          <Typography variant="body2" className={styles.helpTitle}>
            {Vocabulary.needHelp}
          </Typography>
          <Typography variant="body2" className={styles.helpMessage}>
            {Vocabulary.needHelpMessage}
          </Typography>
        </div>

        <Button
          variant="contained"
          href="mailto:contact@xauto.ro"
          className={styles.contactButton}
        >
          {Vocabulary.contactSupport}
        </Button>
      </div>
    </div>
  );
}
